import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle"];

  toggle() {
    this.toggleTargets.forEach((el) => el.classList.toggle("hidden"));
  }

  hide() {
    this.toggleTargets.forEach((el) => el.classList.add("hidden"));
  }

  show() {
    this.toggleTargets.forEach((el) => el.classList.remove("hidden"));
  }
}
